import { render, staticRenderFns } from "./NavLinksUser.vue?vue&type=template&id=45e0da98&scoped=true"
import script from "./NavLinksUser.vue?vue&type=script&lang=js"
export * from "./NavLinksUser.vue?vue&type=script&lang=js"
import style0 from "./NavLinksUser.vue?vue&type=style&index=0&id=45e0da98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0da98",
  null
  
)

export default component.exports